var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _g, _rect8, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_48)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_0_48)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint0_radial_0_48)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint1_radial_0_48)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint2_radial_0_48)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint3_radial_0_48)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint4_radial_0_48)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5238,
    width: 14,
    height: 14,
    rx: 6,
    fill: "url(#paint5_radial_0_48)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.7738C31.5 26.188 31.1642 26.5238 30.75 26.5238C30.3358 26.5238 30 26.188 30 25.7738C30 25.3596 30.3358 25.0238 30.75 25.0238C31.1642 25.0238 31.5 25.3596 31.5 25.7738Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 31.0238C29.3807 31.0238 30.5 29.9045 30.5 28.5238C30.5 27.1431 29.3807 26.0238 28 26.0238C26.6193 26.0238 25.5 27.1431 25.5 28.5238C25.5 29.9045 26.6193 31.0238 28 31.0238ZM28 30.0238C28.8284 30.0238 29.5 29.3522 29.5 28.5238C29.5 27.6954 28.8284 27.0238 28 27.0238C27.1716 27.0238 26.5 27.6954 26.5 28.5238C26.5 29.3522 27.1716 30.0238 28 30.0238Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 28.3238C23 26.6436 23 25.8036 23.327 25.1618C23.6146 24.5973 24.0735 24.1384 24.638 23.8508C25.2798 23.5238 26.1198 23.5238 27.8 23.5238H28.2C29.8802 23.5238 30.7202 23.5238 31.362 23.8508C31.9265 24.1384 32.3854 24.5973 32.673 25.1618C33 25.8036 33 26.6436 33 28.3238V28.7238C33 30.404 33 31.244 32.673 31.8858C32.3854 32.4503 31.9265 32.9092 31.362 33.1968C30.7202 33.5238 29.8802 33.5238 28.2 33.5238H27.8C26.1198 33.5238 25.2798 33.5238 24.638 33.1968C24.0735 32.9092 23.6146 32.4503 23.327 31.8858C23 31.244 23 30.404 23 28.7238V28.3238ZM27.8 24.5238H28.2C29.0566 24.5238 29.6389 24.5246 30.089 24.5614C30.5274 24.5972 30.7516 24.6621 30.908 24.7418C31.2843 24.9335 31.5903 25.2395 31.782 25.6158C31.8617 25.7722 31.9266 25.9964 31.9624 26.4348C31.9992 26.8849 32 27.4672 32 28.3238V28.7238C32 29.5804 31.9992 30.1627 31.9624 30.6128C31.9266 31.0512 31.8617 31.2754 31.782 31.4318C31.5903 31.8081 31.2843 32.1141 30.908 32.3058C30.7516 32.3855 30.5274 32.4504 30.089 32.4863C29.6389 32.523 29.0566 32.5238 28.2 32.5238H27.8C26.9434 32.5238 26.3611 32.523 25.911 32.4863C25.4726 32.4504 25.2484 32.3855 25.092 32.3058C24.7157 32.1141 24.4097 31.8081 24.218 31.4318C24.1383 31.2754 24.0734 31.0512 24.0376 30.6128C24.0008 30.1627 24 29.5804 24 28.7238V28.3238C24 27.4672 24.0008 26.8849 24.0376 26.4348C24.0734 25.9964 24.1383 25.7722 24.218 25.6158C24.4097 25.2395 24.7157 24.9335 25.092 24.7418C25.2484 24.6621 25.4726 24.5972 25.911 24.5614C26.3611 24.5246 26.9434 24.5238 27.8 24.5238Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5,
    cy: 60.0238,
    rx: 11.5,
    ry: 6.5,
    fill: "#D4467E"
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 12.6238,
    width: 31.8,
    height: 31.8,
    rx: 15.9,
    stroke: "url(#paint6_radial_0_48)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_0_48)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.5238,
    r: 9,
    fill: "white",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_48",
    x: 2,
    y: 2.5238,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_48",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_48",
    x: 8,
    y: 8.5238,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_0_48"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_48",
    x: 7,
    y: 35.5238,
    width: 59,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_48"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_48",
    x: 0,
    y: 0.523804,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 32.0238) rotate(-55.3758) scale(12.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 36.0238) rotate(-65.1363) scale(11.2971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.25 22.0238) rotate(-8.1301) scale(19.4454 4.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 32.0238) rotate(-55.3758) scale(12.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 36.0238) rotate(-65.1363) scale(11.2971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.25 22.0238) rotate(-8.1301) scale(19.4454 4.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_0_48",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2878 13.4759) rotate(44.0741) scale(43.4569 69.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.079b1eb477570186163d908affaed07d.svg";
export { ForwardRef as ReactComponent };